"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPins = void 0;
var myokay_map3_1 = require("@okay/myokay-map3");
exports.getPins = function (blocks, selectedPhaseId) {
    var _a;
    if (!blocks || !blocks.length)
        return [];
    var activePhaseId = ((_a = blocks.find(function (it) { return it.active; })) === null || _a === void 0 ? void 0 : _a.parentPhaseId) || 0;
    var pins = blocks.map(function (it) {
        return {
            lat: it.location.lat,
            lng: it.location.lng,
            type: myokay_map3_1.PinTypes.DOT,
            value: it.active ? 2 : (activePhaseId && it.parentPhaseId === activePhaseId ? 1 : (selectedPhaseId > -1 && selectedPhaseId !== it.parentPhaseId ? -1 : 0)),
            title: it.name,
            popupActive: it.active,
        };
    });
    var pinsGroup = [];
    pins.forEach(function (it) {
        var key = it.lat + "-" + it.lng;
        var existingIndex = pinsGroup.findIndex(function (it) { return it.key === key; });
        if (existingIndex === -1) {
            pinsGroup.push({ key: key, pins: [it] });
        }
        else {
            pinsGroup[existingIndex].pins.push(it);
        }
    });
    return pinsGroup.map(function (it) {
        var pinLength = it.pins.length;
        if (pinLength === 1) {
            return it.pins[0];
        }
        else if (pinLength > 1) {
            return __assign(__assign({}, it.pins[0]), { title: "(" + pinLength + ")" });
        }
    });
};
